export class ReadMoreLessService {
    constructor(
        private defaultReadText = 'View more',
        private defaultHideText = 'View less'
    ) {}

    toggleText(feedBoxCard: HTMLElement) {
        const feedText = feedBoxCard.querySelector('.feed-text') as HTMLElement | null;
        const button = feedBoxCard.querySelector('.read-more-less-btn') as HTMLButtonElement | null;

        // Ensure all elements exist before proceeding
        if (button && feedText) {
            if (feedText.classList.contains('line-clamp-4')) {
                feedText.classList.remove('line-clamp-4', 'group-[.is-list]:line-clamp-2');
                button.previousElementSibling?.classList.add('hidden');
                button.textContent = this.defaultHideText;
            } else {
                feedText.classList.add('line-clamp-4', 'group-[.is-list]:line-clamp-2');
                button.previousElementSibling?.classList.remove('hidden');
                button.textContent = this.defaultReadText;
            }
        }
    }

    initializeReadMoreButtons(container: HTMLElement) {
        const buttons = container.querySelectorAll('.read-more-less-btn') as NodeListOf<HTMLButtonElement>;

        buttons.forEach(button => {
            const feedBoxCard = button.closest('.feedbox-card') as HTMLElement | null;

            // Ensure feedBoxCard exists before adding event listener
            if (feedBoxCard) {
                button.addEventListener('click', () => {
                    this.toggleText(feedBoxCard);
                });
            }
        });
    }
}